<template>
  <div class="component-form">
    <h1 class="form-title">Video Introduction</h1>
    <p class="text mt-30">
      Please submit a 30 second video introducing yourself and the topic you’ll be teaching. This can be something very simple filmed on your phone/computer
      camera — the students are really excited to see you guys!
    </p>
    <FileUploader
      class="mt-20 inp-wrap big"
      text="Upload Video"
      :acceptType="['MP4', 'AVI', 'MOV']"
      :value="value.video"
      @input="handleInput($event, 'video')"
      loadText="loading"
      msg="Less than 500 MB"
      showMsg
      :maxSize="500"
      :role="ROLES.SL"
    />
    <Button class="btn-submit mt-50" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import ROLES from '../../../../utils/roles';
import { Button, FileUploader } from '../../../../components/form';
export default {
  name: 'VideoIntroduction',
  components: {
    Button,
    FileUploader
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    ROLES() {
      return ROLES;
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    }
  }
};
</script>
